/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Per_MonthInputs */

const en_mk_price_per_month = /** @type {(inputs: Mk_Price_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mo`)
};

const id_mk_price_per_month = /** @type {(inputs: Mk_Price_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/bln`)
};

/**
* | output |
* | --- |
* | "/mo" |
*
* @param {Mk_Price_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_per_month = /** @type {((inputs?: Mk_Price_Per_MonthInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Per_MonthInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_per_month(inputs)
	return en_mk_price_per_month(inputs)
});